import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { IonDateTimePickerModule } from '../ion-date-time-picker/ion-date-time-picker.module';
import { DatePickerComponent } from './date-picker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  declarations : [
    DatePickerComponent
  ],
  imports: [
    SharedModule,
    IonDateTimePickerModule,
    NgxDaterangepickerMd
  ],
  exports: [DatePickerComponent]
})
export class DatePickerModule { }
